import goldAvatar from "../../shared/img/player_avatar_gold.png";

// Preload + decode the avatar PNG once so it's cached before avatars animate in (otherwise the
// ring/name appear first and the image pops in late).
if (typeof Image !== "undefined") {
  const preload = new Image();
  preload.src = goldAvatar;
  if (preload.decode) preload.decode().catch(() => {});
}

// First 5 colors are the fixed palette; beyond that, colors are generated.
const BASE_COLORS = ["#D36667", "#A7C577", "#7F97C2", "#CA8755", "#C6C969"];

// CSS filter presets for each base color (gold base hue ~45deg)
const COLOR_FILTERS: Record<string, string> = {
  "#D36667": "hue-rotate(315deg) saturate(1.3)",
  "#A7C577": "hue-rotate(45deg) saturate(0.8)",
  "#7F97C2": "hue-rotate(170deg) saturate(0.6) brightness(0.95)",
  "#CA8755": "hue-rotate(345deg) saturate(1.1)",
  "#C6C969": "hue-rotate(17deg) saturate(0.9)",
};

/** Generate a visually distinct color for player indices beyond the base palette. */
function generateColor(index: number): string {
  // Use golden angle to spread hues evenly
  const hue = ((index - BASE_COLORS.length) * 137.508 + 180) % 360;
  return `hsl(${Math.round(hue)}, 55%, 55%)`;
}

/** Get the CSS filter string for a given color hex or hsl string. */
function getFilter(color: string): string {
  if (COLOR_FILTERS[color]) return COLOR_FILTERS[color];
  // For generated HSL colors, extract hue and compute rotation from gold (~45deg)
  const match = color.match(/hsl\((\d+)/);
  if (match) {
    const hue = parseInt(match[1], 10);
    const rotation = (hue - 45 + 360) % 360;
    return `hue-rotate(${rotation}deg) saturate(0.7)`;
  }
  return "none";
}

/** Get player color by index. First 5 use the fixed palette, rest are generated. */
export function getPlayerColor(index: number): string {
  if (index < BASE_COLORS.length) return BASE_COLORS[index];
  return generateColor(index);
}

export const PLAYER_COLORS = BASE_COLORS;

interface PlayerAvatarProps {
  color: string;
  size: number;
}

export default function PlayerAvatar({ color, size }: PlayerAvatarProps) {
  return (
    <img
      src={goldAvatar}
      alt=""
      decoding="sync"
      loading="eager"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        filter: getFilter(color),
        display: "block",
      }}
    />
  );
}
